module.exports = __webpack_public_path__ + "static/she-had-a-bite-03e78e21dcbf571621556c373b8f57bc.jpg";